//#region src/hooks/mounted-swr-keys.ts
var e = /* @__PURE__ */ new Map(), t = (t) => (e.set(t, (e.get(t) ?? 0) + 1), () => {
	let n = e.get(t) ?? 0;
	n > 1 ? e.set(t, n - 1) : e.delete(t);
}), n = (t) => e.has(t);
//#endregion
export { n as isSwrKeyMounted, t as mountSwrKey };
